import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Col } from 'react-bootstrap'
import { useHistory } from 'react-router'
import TagSymbol from '../../../components/Molecules/Symbols/Symbol'
import ItemActions from '../Customization/categoriesSelection/ItemActions'
import FavoriteButton from '../Customization/FavoriteButton'
import styleClasses from "../../../../src/containers/try2/try2.module.scss";
import { GUEST_USER, REACT_APP_CLOUD_FRONT, REACT_APP_SOUP_CATEGORY_ID_FOR_TRY2COMBO_ADDONS_UPSELL } from '../../../constants'
import { ICustomizedItem } from '../../../models/item.model'
import { toFixedNumber } from '../../../priceCalculation/helper'
import { verifyStatus } from '../../../helpers/customizedItem/customizedItem.helper'
import { isItCreateYourOwnItem } from '../../../helpers/helperMethods'

interface ITryItemDescription {
    item : ICustomizedItem
    addToComboClickHandler:(item: ICustomizedItem) => void
    customizeModal: (item: ICustomizedItem) => void
    showDetailsHandler:any
    category: any
    favourite: { id: number; item_id: number; isSelected: boolean }[]
    favButtonHandler: (e:React.MouseEvent<HTMLButtonElement> ,item: ICustomizedItem) => void;
    favIcon: boolean
    userId:string
    userType:string
    showItemDetails:boolean
}

const TryItemDescription:React.FC<ITryItemDescription> = (props) => {

    const {showItemDetails, userId, userType,item, addToComboClickHandler, customizeModal,showDetailsHandler,category,favourite,favButtonHandler,favIcon} = props;

    const [trydivHeight, setTryDivHeight] = useState(0);
    const tryitemHeight = useRef(null);
    const tryheightSetRef = useRef(null);
    const history = useHistory()
    

    // const showCalories = (calories: string | number, name: string) => {
    //     if(calories > 0){
    //       return `${calories} Cal`
    //     }else if (isItCreateYourOwnItem(name)){
    //       return 'Calories Vary'
    //     }
    //     return ''
    //   }

      const itemAdditionalPrice = (
        basePrice: number,
        half_brink_item_price: number,
        fullPrice: number
      ) => {
        const itemPrice = half_brink_item_price ? half_brink_item_price : fullPrice;
        const price: number = toFixedNumber(itemPrice - basePrice);
        if (price > 0) {
          return Number.isInteger(price) ? `Extra Price $${price}.00` :`Extra Price $${price}`;
        }
      };
      const showFavrtButton = (item) => {
        if(userId && userType !== GUEST_USER && !isItCreateYourOwnItem(item?.is_create_your_own)){
          return true
        }
        return false
      }
      useEffect(() => {
        if ((!trydivHeight || trydivHeight <= 0)  && tryitemHeight?.current && tryitemHeight?.current?.scrollHeight  && tryheightSetRef?.current === null) {
            setTryDivHeight(tryitemHeight?.current?.scrollHeight);
          tryheightSetRef.current = true;
        }
      }, [item, showItemDetails]);

      const widgetCLickHandler = (item: any) => {
        if (!item.is_active || !verifyStatus(item, 'item_location')) {
          return;
        } else if (
          item?.category_id == REACT_APP_SOUP_CATEGORY_ID_FOR_TRY2COMBO_ADDONS_UPSELL &&
          item?.items_required_modifier_groups.length <= 0
        ) {
          customizeModal(item);
        } else {
          addToComboClickHandler(item);
        }
      };

  return (
    <>
        <Col
          lg="4"
          md="6"
          sm="12"
          className={`${styleClasses.try2_item_img_wrap} ${styleClasses.car_col} mb-4`}
          key={item.id}
        >
          <div
            className={`${styleClasses.item_main_div} d-flex flex-column h-100 text-start`}
            onClick={() => widgetCLickHandler(item)}
            data-testid="Try2ComboItems"
          >
            <div className={styleClasses.item_img_wrap}>
              <img
                src={`${REACT_APP_CLOUD_FRONT}${item.image}`}
                className={`img-fluid ${item.is_active && verifyStatus(item, 'item_location') ? '' : styleClasses.is_not_active}`}
                alt={item.name}
              />
              {showFavrtButton(item) && (
                <FavoriteButton
                favIcon={favIcon}
                buttonHandler={favButtonHandler}
                className={`${styleClasses.favbtn} d-none d-md-block`}
                item={item}
                favourite={favourite.some((fav) => fav.item_id === item.id)} isIconblueFill={false}                />
              )}
            </div>
            <div
              className={`${styleClasses.item_title_wrap} menu-title d-flex align-items-start justify-content-start text-start py-2`}
            >
              <h6 className="sub_title1 text-truncate">{item.name}</h6>
              <div className='d-md-block d-none'><TagSymbol tags={item.tags} /></div>
              {showFavrtButton(item) && (
                <FavoriteButton
                favIcon={favIcon}
                buttonHandler={favButtonHandler}
                className={`${styleClasses.favbtn} d-md-none position-static flex-fill text-end`}
                item={item}
                favourite={favourite.some((fav) => fav.item_id === item.id)} isIconblueFill={false}                />
              )}
            </div>
            <div className='d-md-none d-block'><TagSymbol tags={item.tags} /></div>
            {/* Exlude, feedback point number 302 */}
            {/* <div className="d-flex justify-content-between">
              <h6 className="h-14 clr-text-grey font-rale mb-3">
                {showCalories(item.calories, item.name)}
              </h6>
              <h6 className="text-start clr-dark-red lh-normal f-s12 font-Visby-cf f-w6 ls-normal text-uppercase">
                { itemAdditionalPrice(
                  category?.base,
                  item?.half_brink_item_price,
                  item?.price
                )}
              </h6>
            </div> */}
            <p
              ref={tryitemHeight}
              className={`${styleClasses.item_subtitle_wrap} text-start mb-0 p-16`}
            >
              {item.description}
            </p>
            <p 
            className={`${styleClasses.item_subtitle_wrap} ${styleClasses.try_show_more} text-end p-16`}>
              {trydivHeight > 58 && <button
                type="button"
                className={`${styleClasses.item_subtitle_button} btn btn-custom p-0 f-w6 p-16`}
                onClick={(e) => showDetailsHandler(e, item)}
              >
                Show more
              </button>}
            </p>
 
            <ItemActions
              item={item}
              customizeModal={customizeModal}
              addToComboClickHandler={addToComboClickHandler}
            />
          </div>
        </Col>
    </>
  )
}

export default TryItemDescription
